import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { useCart } from "../context/CartContext";
import { pickLang, t } from "../lib/i18n";
import { Plus, ArrowUpRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ProductCard({ product }) {
  const { lang } = useLang();
  const { add } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    add(product);
    toast.success(lang === "gr" ? "Προστέθηκε στην προσφορά" : "Added to quote");
  };

  const openSpec = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (product.spec_url) window.open(product.spec_url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="card-dark group relative" data-testid={`product-card-${product.id}`}>
      <Link to={`/products/${product.id}`} className="block">
        <div className="aspect-[4/3] overflow-hidden bg-[#080809]">
          {product.image && (
            <img src={product.image} alt={pickLang(product.name, lang)}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          )}
        </div>
        <div className="p-5">
          <div className="flex items-start justify-between gap-3 mb-2">
            <div>
              <div className="mono-font text-[10px] uppercase tracking-[0.25em] text-gray-500">{product.brand}</div>
              <h3 className="display-font text-lg font-bold mt-1 leading-tight">{pickLang(product.name, lang)}</h3>
            </div>
            <ArrowUpRight size={18} className="text-gray-500 group-hover:text-[#ccff00] mt-1 shrink-0" />
          </div>
          <p className="text-sm text-gray-400 mt-2 line-clamp-2">{pickLang(product.short_desc, lang)}</p>
          <div className="flex items-center justify-between mt-5">
            <span className="mono-font text-xs text-[#ccff00]">{product.price_text}</span>
            <div className="flex items-center gap-3">
              {product.spec_url && (
                <button onClick={openSpec}
                  className="mono-font text-[10px] tracking-widest uppercase text-gray-400 hover:text-[#ccff00] underline-offset-4 hover:underline"
                  data-testid={`spec-sheet-${product.id}`}
                  title={lang === "gr" ? "Φύλλο προδιαγραφών" : "Spec sheet"}
                >
                  {lang === "gr" ? "Specs ↗" : "Specs ↗"}
                </button>
              )}
              <button onClick={handleAdd}
                className="flex items-center gap-1 mono-font text-[11px] tracking-widest uppercase text-white hover:text-[#ccff00]"
                data-testid={`add-to-quote-${product.id}`}>
                <Plus size={14} weight="bold" /> {t("cta.add_to_quote", lang)}
              </button>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
